import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner5-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import TitleImg from "../assets/Images/title.png";
import CardImg1 from "../assets/Images/radio1-286x160.png";
import CardImg2 from "../assets/Images/radio2-286x160.png";
import CardImg3 from "../assets/Images/radio3-286x160.png";
import CardImg4 from "../assets/Images/radio4-286x160.png";
import CardImg5 from "../assets/Images/radio5-286x160.png";
import CardImg6 from "../assets/Images/radio6-286x160.png";
import CardImg7 from "../assets/Images/radio7-286x160.png";
import CardImg8 from "../assets/Images/radio8-286x160.png";
import CardImg9 from "../assets/Images/radio9-286x160.png";
import CardImg10 from "../assets/Images/radio10-286x160.png";
import CardImg11 from "../assets/Images/radio11-286x160.png";
import CardImg12 from "../assets/Images/radio12-286x160.png";
import CardImg13 from "../assets/Images/radio13-286x160.png";
import "./RadioProgramPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RadioProgramPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">
            {t("radio_program_page_header")}
          </h1>
          <p className="banner-subtitle">{t("radio_program_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_radio_program_page_link1")}</Link>
        <span>{t("breadcrumbs_radio_program_page_span")}</span>
        <Link>{t("breadcrumbs_radio_program_page_link2")}</Link>
      </Breadcrumbs>
      <main className="radio-main-container">
        <header className="radio-header-section">
          <div className="radio-title-container">
            <img src={TitleImg} alt="Title icon" className="radio-title-icon" />
            <h2 className="radio-section-title">
              {t("radio_program_page_h3")}
            </h2>
          </div>
          <div className="radio-intro-text">
            <p className="radio-intro-paragraph">
              {t("radio_program_page_text1")}
            </p>
            <p className="radio-intro-paragraph">
              {t("radio_program_page_text2")}
            </p>
          </div>
        </header>
        <section className="radio-program-cards">
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg1}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text3")}</p>
              <p className="card-paragraph">{t("radio_program_page_text4")}</p>
              <p className="card-paragraph">{t("radio_program_page_text5")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP1.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg2}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text6")}</p>
              <p className="card-paragraph">{t("radio_program_page_text7")}</p>
              <p className="card-paragraph">{t("radio_program_page_text8")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP2.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg3}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text9")}</p>
              <p className="card-paragraph">{t("radio_program_page_text10")}</p>
              <p className="card-paragraph">{t("radio_program_page_text11")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP3.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg4}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text12")}</p>
              <p className="card-paragraph">{t("radio_program_page_text13")}</p>
              <p className="card-paragraph">{t("radio_program_page_text14")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP4.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg5}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text15")}</p>
              <p className="card-paragraph">{t("radio_program_page_text16")}</p>
              <p className="card-paragraph">{t("radio_program_page_text17")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP5.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg6}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text18")}</p>
              <p className="card-paragraph">{t("radio_program_page_text19")}</p>
              <p className="card-paragraph">{t("radio_program_page_text20")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP6.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg7}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text21")}</p>
              <p className="card-paragraph">{t("radio_program_page_text22")}</p>
              <p className="card-paragraph">{t("radio_program_page_text23")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP7.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg8}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text24")}</p>
              <p className="card-paragraph">{t("radio_program_page_text25")}</p>
              <p className="card-paragraph">{t("radio_program_page_text26")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP8.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg9}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text27")}</p>
              <p className="card-paragraph">{t("radio_program_page_text28")}</p>
              <p className="card-paragraph">{t("radio_program_page_text29")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP9.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg10}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text30")}</p>
              <p className="card-paragraph">{t("radio_program_page_text31")}</p>
              <p className="card-paragraph">{t("radio_program_page_text32")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP10.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg11}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text33")}</p>
              <p className="card-paragraph">{t("radio_program_page_text34")}</p>
              <p className="card-paragraph">{t("radio_program_page_text35")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP11.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg12}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text36")}</p>
              <p className="card-paragraph">{t("radio_program_page_text37")}</p>
              <p className="card-paragraph">{t("radio_program_page_text38")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP12.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
          <article className="radio-card">
            <div className="card-image-container">
              <img
                src={CardImg13}
                alt="Radio program episode"
                className="card-image"
              />
            </div>
            <div className="card-content">
              <p className="card-paragraph">{t("radio_program_page_text39")}</p>
              <p className="card-paragraph">{t("radio_program_page_text40")}</p>
              <p className="card-paragraph">{t("radio_program_page_text41")}</p>
            </div>
            <div className="card-btns">
              <a
                href="https://www.rthk.hk/radio/dab31/programme/g0457_resolutions_to_disputes"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img1")}
                  alt="Visit website"
                />
              </a>
              <a
                href="https://www.hkarbsoc.org.hk/image/catalog/radio/G0457EP13.mp3"
                target="_blank"
                rel="noopener noreferrer"
                className="card-btn"
              >
                <img
                  src={t("radio_program_page_card_img2")}
                  alt="Download audio"
                />
              </a>
            </div>
          </article>
        </section>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>
      <Footer />
    </>
  );
};

export default RadioProgramPage;
